export default __webpack_public_path__ + "static/media/ramper-wallet-logo.68ebb4d2.svg";